var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/**
 * This is a simple number-entry widget
 * It is not as powerful as number-input, but has a simpler, more
 * representative structure as an example widget, and is easier to
 * test new ideas on.
 *
 * TODO(jack): Add more comments
 */

var React = require("react");
var Changeable = require("../mixins/changeable.jsx");
var _ = require("underscore");

var TextInput = React.createClass({
    displayName: "TextInput",

    render: function render() {
        return React.createElement("input", {
            ref: "input",
            value: this.props.value || "",
            onChange: this.changeValue
        });
    },

    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    changeValue: function changeValue(e) {
        // Translating from the js event e to the value
        // of the textbox to send to onChange
        this.props.onChange(e.target.value);
    }
});

/**
 * This is the widget's renderer. It shows up in the right column
 * in the demo, and is what is visible to users, and where
 * users enter their answers.
 */
var ExampleWidget = React.createClass({
    displayName: "ExampleWidget",

    propTypes: _extends({}, Changeable.propTypes, {
        value: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            value: ""
        };
    },

    /**
     * Tell our parent to update our props.
     */
    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(TextInput, {
            ref: "input",
            value: this.props.value,
            onChange: this.change("value")
        });
    },

    getUserInput: function getUserInput() {
        return this.props.value;
    },

    /**
     * Widgets that are focusable should add a focus method that returns
     * true if focusing succeeded. The first such widget found will be
     * focused on page load.
     */
    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    /**
     * simpleValidate is called for grading. Rubric is the result of calling
     * getUserInput() on the editor that created this widget.
     *
     * Should return an object representing the grading result, such as
     * {
     *     type: "points",
     *     earned: 1,
     *     total: 1,
     *     message: null
     * }
     */
    simpleValidate: function simpleValidate(rubric) {
        return ExampleWidget.validate(this.getUserInput(), rubric);
    }
});

/**
 * This is the widget's grading function
 */
_.extend(ExampleWidget, {
    /**
     * simpleValidate generally defers to this function
     *
     * value is usually the result of getUserInput on the widget
     * rubric is the result of calling serialize() on the editor
     */
    validate: function validate(value, rubric) {
        if (value === "") {
            return {
                type: "invalid",
                message: "It looks like you haven't answered all of the " + "question yet."
            };
        } else if (value === rubric.correct) {
            return {
                type: "points",
                earned: 1,
                total: 1,
                message: null
            };
        } else {
            return {
                type: "points",
                earned: 0,
                total: 1,
                message: null
            };
        }
    }
});

/**
 * For this widget to work, we must require() this file in src/all-widgets.js
 */
module.exports = {
    name: "example-widget",
    displayName: "Example Widget",

    // Tell the renderer what type of `display:` style we would like
    // for the component wrapping this one.
    defaultAlignment: "inline-block",

    hidden: true, // Hides this widget from the Perseus.Editor widget select
    widget: ExampleWidget
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/example-widget.jsx
 ** module id = 160
 ** module chunks = 0 1
 **/